import { Dayjs } from 'dayjs';

export const prepareTime = (time: Dayjs): string =>
  time.format('YYYY-MM-DD HH:mm:ss');

export const timeOptions = Array.from({ length: 48 }, (_, i) => {
  const hours = Math.floor(i / 2)
    .toString()
    .padStart(2, '0');
  const minutes = i % 2 === 0 ? '00' : '30';
  return { value: `${hours}:${minutes}`, title: `${hours}:${minutes}` };
});

export const clockOptions = Array.from({ length: 48 }, (_, i) => {
  const value = (i + 1) * 0.5;
  const formattedValue = Number.isInteger(value)
    ? value.toString() // Для целых чисел (например, 1, 2)
    : value.toFixed(1).replace(',', '.');

  return { value: formattedValue, title: formattedValue };
});
